declare var Sortable: any;

/* eslint-disable-next-line */
var apt: any = apt || {};
apt.dragDrop = (function ($: JQueryStatic) {
	let _sortableSrc: any;
	let _sortableDest: any;

	function _init() {
		_sortableSrc = Sortable.create(document.querySelector("[data-element='source']") || document.createElement("ul"), {
			group: {
				name: 'sortable',
				pull: true,
				put: false
			}
		});

		_sortableSrc.sort = false;

		_sortableDest = Sortable.create(document.querySelector("[data-element='dest']") || document.createElement("ul"), {
			group: {
				name: 'sortable',
				pull: false,
				put: true
			},
			onSort: () => {
				$("#destPlaceholder").remove();
				$.each($(_sortableDest.el).children("li"), (index: number, element: HTMLElement) => {
					$(element).find("input").attr("value", index + 1);

					$(element).find("i")
						.removeClass("bi-arrow-right")
						.addClass("bi-arrows-vertical");
				});
			}
		});
	}

	return {
		init: _init
	}
})($);